// Query key factory for consistent query key management
export const queryKeys = {
  // Transactions
  transactions: {
    all: ["transactions"],
    list: (params) => ["transactions", "list", params],
    detail: (id) => ["transactions", "detail", id],
    history: (id) => ["transactions", "history", id],
    add: (params) => ["transactions", "add", params],
  },

  // Financial data
  financial: {
    summary: (params) => ["financial", "summary", params],
    advisor: (params) => ["financial", "advisor", params],
  },

  // Categories
  categories: {
    all: ["categories"],
    spending: (params) => ["categories", "spending", params],
    subSpending: (params) => ["categories", "sub-spending", params],
    historicalAverage: (params) => ["categories", "historical-average", params],
    ninetyDayAverage: (params) => ["categories", "90-day-average", params], // deprecated
  },

  // Daily spending
  dailySpending: (params) => ["daily-spending", params],

  // Budget
  budget: {
    comparison: (params) => ["budget", "comparison", params],
  },

  // Keywords
  keywords: {
    all: ["keywords"],
  },

  // Monthly expenses
  monthlyExpenses: {
    all: ["monthly-expenses"],
  },
};

// Query key utilities
export const queryKeyUtils = {
  // Get all query keys that should be invalidated when transactions change
  getTransactionRelatedKeys: (params = {}) => [
    queryKeys.transactions.all,
    queryKeys.financial.summary(params),
    queryKeys.categories.spending(params),
    queryKeys.categories.subSpending(params),
    queryKeys.dailySpending(params),
    queryKeys.budget.comparison(params),
  ],

  // Get all query keys that should be invalidated when keywords change
  getKeywordRelatedKeys: () => [
    queryKeys.keywords.all,
    queryKeys.transactions.all,
    queryKeys.categories.spending(),
    queryKeys.categories.subSpending(),
    queryKeys.categories.historicalAverage(),
    queryKeys.categories.ninetyDayAverage(),
    queryKeys.financial.summary(),
    queryKeys.dailySpending(),
    queryKeys.budget.comparison(),
  ],

  // Get all query keys that should be invalidated when monthly expenses change
  getMonthlyExpenseRelatedKeys: () => [
    queryKeys.monthlyExpenses.all,
    queryKeys.financial.summary(),
    queryKeys.budget.comparison(),
    queryKeys.dailySpending(),
    queryKeys.categories.spending(),
    queryKeys.categories.subSpending(),
  ],

  // Get all query keys that should be invalidated when budget data changes
  getBudgetRelatedKeys: () => [
    queryKeys.budget.comparison(),
    queryKeys.financial.summary(),
    queryKeys.monthlyExpenses.all,
  ],

  // Invalidate all data-dependent queries (comprehensive refresh)
  getAllDataRelatedKeys: () => [
    queryKeys.transactions.all,
    queryKeys.financial.summary(),
    queryKeys.categories.spending(),
    queryKeys.categories.subSpending(),
    queryKeys.categories.historicalAverage(),
    queryKeys.categories.ninetyDayAverage(),
    queryKeys.dailySpending(),
    queryKeys.budget.comparison(),
    queryKeys.monthlyExpenses.all,
    queryKeys.keywords.all,
    queryKeys.categories.all,
  ],
};
